import { IEmailPreferences } from "../types/userpreferences";
import { graphResponse } from "./network";

const userEmailPreferencesApi = "{{vroomOrigin}}/{{apiVersion2}}/drive/userPreferences/email";

export function getUserEmailPreferences(fetch: (url: string, init?: RequestInit) => Promise<Response>): Promise<IEmailPreferences> {
  return graphResponse(fetch(userEmailPreferencesApi));
}
